/*  ========================================================================
    # Hooks - Use Translation
    ========================================================================  */

export default function useTranslation() {
  return (key, replacements = {}) => {
    let value = window.translations?.[key] || key;

    for (const [placeholder, replaceWith] of Object.entries(replacements)) {
      value = value.replaceAll(`{${placeholder}}`, replaceWith);
    }

    return value;
  };
}
